// extracted by mini-css-extract-plugin
export default {"Projects__section":"Projects_Projects__section__amnJF","projects__heading":"Projects_projects__heading__IchEW","projects__grid":"Projects_projects__grid__KBil9"};